module.exports = __webpack_public_path__ + "static/spotify-11a7f73641e395c68eaf70b45386efcb.png";